var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileHome = function SvgCategoryMobileHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_home_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_home_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "category_mobile_home_svg__Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_home_svg__st0",
    d: "M35.6 25.7c-3.6-3.3-7.2-6.6-10.7-9.8l-3.1 2.7v-1.7H18V22l-3.6 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_home_svg__st0",
    d: "m17.3 25.4-.2 7.8h15.4v-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_home_svg__st0",
    d: "M25.2 25h3.9v3.9h-3.9z"
  }))));
};
export default SvgCategoryMobileHome;